module.exports = __webpack_public_path__ + "static/media/brands_schneider.4fd5cb29.svg";